import { render, staticRenderFns } from "./ModalResolve.vue?vue&type=template&id=e096c8e2"
import script from "./ModalResolve.vue?vue&type=script&lang=js"
export * from "./ModalResolve.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports